import React, { useState, useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { Box, CircularProgress, Typography } from '@mui/material';
import { useAuth } from '../hooks/useAuth';
import { subscriptionApi } from '../services/api';

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, isLoading, tokenReady } = useAuth();
  const location = useLocation();
  const [subscriptionChecked, setSubscriptionChecked] = useState(false);
  
  console.log('🛡️ ProtectedRoute:', { isAuthenticated, isLoading, tokenReady, path: location.pathname });

  // Fetch subscription status after authentication (for UI indicators only, not gating)
  useEffect(() => {
    if (isAuthenticated && tokenReady) {
      subscriptionApi.getStatus()
        .then(() => {
          setSubscriptionChecked(true);
        })
        .catch(error => {
          console.error('🛡️ Subscription check failed:', error);
          setSubscriptionChecked(true);
        });
    }
  }, [isAuthenticated, tokenReady]);

  // Show loading spinner while checking authentication
  if (isLoading) {
    return (
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          height: '100vh',
          gap: 2,
        }}
      >
        <CircularProgress size={60} />
        <Typography variant="h6" color="text.secondary">
          Loading...
        </Typography>
      </Box>
    );
  }

  // Redirect to login if not authenticated
  if (!isAuthenticated) {
    console.log('🛡️ ProtectedRoute: Not authenticated, redirecting to login');
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Wait for subscription check to complete (for UI state), but don't gate access
  if (!subscriptionChecked) {
    return (
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          height: '100vh',
          gap: 2,
        }}
      >
        <CircularProgress size={60} />
        <Typography variant="h6" color="text.secondary">
          Loading...
        </Typography>
      </Box>
    );
  }

  // All authenticated users can access all pages.
  // Subscription/page-limit checks are enforced server-side on processing routes only.
  return children;
};

export default ProtectedRoute;
